<template>
  <BasicModal
    :title="'ロボ作成依頼'"
    :isShowModal="isCardModalActive"
    :canCancel="true"
    @cancel="cancel">
    <div class="card" style="border-radius: 5px;">
      <div class="card-content">
        <!-- 件名 -->
        <div class="request-title">
          <div>
            件名
          </div>
          <div class="request-item-value">
            <input class="input title-input" type="text" v-model="requestTitle" />
          </div>
        </div>
        <!-- 内容 -->
        <div class="request-content">
          <div>
            内容
          </div>
          <div class="request-item-value">
            <textarea class="textarea content-input disp-scroll" v-model="requestContent" />
          </div>
        </div>
        <!-- メールアドレス -->
        <div class="request-email">
          <div>
            Email
          </div>
          <div class="request-item-value">
            <input class="input email-input" type="email" v-model="requestEmail" />
          </div>
        </div>
        <!-- メッセージ -->
        <div class="request-message">
          作成依頼を受付いたしております。ご要望内容をお聞かせください。
        </div>
      </div>
      <div class="card-footer">
        <a class="card-footer-item" @click="sendRequest()">送信する</a>
      </div>
    </div>
  </BasicModal>
</template>

<script>
import BasicModal      from '@/components/Modals/BasicModal'
import controlLogMixin from '@/mixins/controlLogMixin'
import {isMailAddress} from '@/functions/common/checksFunc'

export default {
  name: 'RoboCreateRequest',
  componentName: 'RoboCreateRequest',
  components: {
    BasicModal,
  },
  mixins: [
    controlLogMixin
  ],
  props: {
    /**
     * ダイアログ開閉フラグ
     * @type  {Object}
     */
    isCardModalActive: {
      type: Boolean,
      default: false,
      required: true
    },
  },
  data () {
    return {
      /**
       * コンポーネント名
       * @type  {String}
       */
      COMPONENT_NAME: 'RoboCreateRequest',
      /**
       * 件名
       * @type  {String}
       */
      requestTitle: '',
      /**
       * 内容
       * @type  {String}
       */
      requestContent: '',
      /**
       * メールアドレス
       * @type  {String}
       */
      requestEmail: '',
    }
  },
  methods: {
    /**
     * ロボ作成依頼送信
     */
    sendRequest () {
      if (!this.requestTitle) {
        alert('件名を入力してください。')
        return
      }
      if (!this.requestContent) {
        alert('内容を入力してください。')
        return
      }
      if (!this.requestEmail) {
        alert('Emailを入力してください。')
        return
      }
      // メールアドレス形式チェック
      const strReturn = isMailAddress(this.requestEmail, 'Email')
      if (strReturn !== '') {
        alert(strReturn)
        return false
      }

      // 記載内容を送信
      const sendData = {
        title: this.requestTitle,
        content: this.requestContent,
        email: this.requestEmail
      }
      this.$store.dispatch('chatbot/roboCreateRequest', sendData)
        .then(result => {
          alert(result)
          this.cancel()
          this.sendControlLog('ロボ作成依頼', 'ロボの作成依頼を送信。')
        })
    },
    /**
     * キャンセル
     */
    cancel () {
      this.$emit('cancel', false)
    }
  }
}
</script>

<style scoped>
.request-title {
  width: 100%;
  margin-bottom: 16px;
}
.request-content {
  width: 100%;
  margin-bottom: 16px;
}
.request-email {
  width: 100%;
  margin-bottom: 32px;
}
.request-message {
  width: 100%;
}
.request-item-value {
  width: 100%;
}
.title-input {
  width: 100%;
}
.content-input {
  width: 100%;
  min-height: 176px;
  max-height: 176px;
}
.email-input {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components2/Robo/modal/RoboCreateRequest.vue